import { Tooltip } from '@/components/Atoms/Tooltip/Tooltip';
import { H4 } from '@/components/Core/Heading';
import type { ElementType, ReactNode } from 'react';
import type { FCC } from 'react-fc';
import styled from 'styled-components';

interface IProps {
    as?: ElementType;
    tooltip?: string;
    actions?: ReactNode;
}

export const SectionHeading: FCC<IProps> = ({ as = 'h2', children, className, tooltip, actions }) => {
    return (
        <Title className={className}>
            <InnerTitle as={as}>
                {children}
                {tooltip && <Tooltip>{tooltip}</Tooltip>}
            </InnerTitle>
            {actions}
        </Title>
    );
};

const Title = styled.div`
    display: flex;
    gap: var(--size-grid-unit);
    flex-wrap: wrap;
    align-items: center;

    &:not(:last-child) {
        margin-bottom: var(--size-grid-half);
    }
`;

const InnerTitle = styled(H4)`
    display: inline-flex;
    gap: var(--size-grid-half);
    align-items: center;
`;
